import {
  ArrowLeftRight,
  Banknote,
  BookOpen,
  Braces,
  Building2,
  CreditCard,
  Landmark,
  LayoutDashboard,
  Percent,
  Receipt,
  Store,
  Users,
  Wallet,
  Webhook
} from 'lucide-react';
import { Permissions } from '../../utils/permissions';

// The Agent entries carry no permission because no `partner.agent-*` permission exists on the
// backend; they are gated on the session's `is_agent` flag through their mode instead.
const navigation = [
  { id: 'dashboard', title: 'Dashboard', to: '/layout/dashboard', icon: LayoutDashboard, permission: Permissions.dashboard, mode: 'partner' },
  { id: 'transactions', title: 'Transactions', to: '/layout/transactions', icon: ArrowLeftRight, permission: Permissions.transactions, mode: 'partner' },
  { id: 'issued-users', title: 'Issued Users', to: '/layout/issued-users', icon: CreditCard, permission: Permissions.issuedUsers, mode: 'partner' },
  { id: 'sub-merchants', title: 'Sub-merchants', to: '/layout/sub-merchants', icon: Building2, permission: Permissions.subMerchantsView, mode: 'partner' },
  { id: 'payouts', title: 'Payouts', to: '/layout/payouts', icon: Banknote, permission: Permissions.payouts, mode: 'partner' },
  { id: 'webhook-logs', title: 'Webhook Logs', to: '/layout/webhook-logs', icon: Webhook, permission: Permissions.webhookLogs, mode: 'partner' },
  { id: 'team', title: 'Team', to: '/layout/team', icon: Users, permission: Permissions.teamView, mode: 'partner' },
  { id: 'developer', title: 'Developer', to: '/layout/developer', icon: Braces, permission: Permissions.settingsAny, mode: 'partner' },
  { id: 'sub-merchant-dashboard', title: 'Dashboard', to: '/layout/sub-merchant-dashboard', icon: LayoutDashboard, permission: Permissions.subMerchantDashboard, mode: 'sub-merchant' },
  { id: 'sub-merchant-transactions', title: 'Transactions', to: '/layout/sub-merchant-transactions', icon: ArrowLeftRight, permission: Permissions.subMerchantTransactions, mode: 'sub-merchant' },
  { id: 'sub-merchant-ledger', title: 'Ledger', to: '/layout/sub-merchant-ledger', icon: BookOpen, permission: Permissions.subMerchantLedger, mode: 'sub-merchant' },
  { id: 'sub-merchant-withdrawals', title: 'Withdrawals', to: '/layout/sub-merchant-withdrawals', icon: Wallet, permission: Permissions.subMerchantWithdrawals, mode: 'sub-merchant' },
  { id: 'sub-merchant-bank-account', title: 'Bank Account', to: '/layout/sub-merchant-bank-account', icon: Landmark, permission: Permissions.subMerchantBankAccountView, mode: 'sub-merchant' },
  { id: 'enterprise-dashboard', title: 'Dashboard', to: '/layout/enterprise-dashboard', icon: LayoutDashboard, permission: Permissions.enterpriseDashboard, mode: 'enterprise' },
  { id: 'enterprise-transactions', title: 'Transactions', to: '/layout/enterprise-transactions', icon: ArrowLeftRight, permission: Permissions.enterpriseTransactions, mode: 'enterprise' },
  { id: 'enterprise-ledger', title: 'Ledger', to: '/layout/enterprise-ledger', icon: BookOpen, permission: Permissions.enterpriseLedger, mode: 'enterprise' },
  { id: 'enterprise-payouts', title: 'Payouts', to: '/layout/enterprise-payouts', icon: Banknote, permission: Permissions.enterprisePayouts, mode: 'enterprise' },
  { id: 'enterprise-bank-account', title: 'Bank Account', to: '/layout/enterprise-bank-account', icon: Landmark, permission: Permissions.enterpriseBankAccount, mode: 'enterprise' },
  { id: 'enterprise-merchants', title: 'Merchants', to: '/layout/enterprise-merchants', icon: Store, permission: Permissions.enterpriseMerchants, mode: 'enterprise' },
  { id: 'agent-dashboard', title: 'Agent Dashboard', to: '/layout/agent-dashboard', icon: Store, permission: null, mode: 'agent' },
  { id: 'agent-transactions', title: 'Agent Transactions', to: '/layout/agent-transactions', icon: Receipt, permission: null, mode: 'agent' },
  { id: 'agent-commissions', title: 'Agent Commissions', to: '/layout/agent-commissions', icon: Percent, permission: null, mode: 'agent' }
];

const sessionMode = ({ isAgent, isEnterprise, isSubMerchant }) => {
  if (isAgent) return 'agent';
  if (isEnterprise) return 'enterprise';
  if (isSubMerchant) return 'sub-merchant';
  return 'partner';
};

export const visibleNavigation = ({ isAgent, isEnterprise, isSubMerchant, hasPermission }) => {
  const mode = sessionMode({ isAgent, isEnterprise, isSubMerchant });
  return navigation.filter(
    (item) => item.mode === mode && (item.permission === null || hasPermission(item.permission))
  );
};

export default navigation;
